import React from "react";

// import {soundAssetConfig} from "../../../data/sounds";


interface IframeworkWrapper {
    data: {}
}

export const frameworkWrapper: IframeworkWrapper = {
    data: {}

};
export const wrapperConfigurationContext = React.createContext(
    {}
);